import { EInfrastructureActionType } from './types';
import { actionGenerator } from '../../../common/utils/redux/actionGenerator';

export const setIsDropdownOpen = actionGenerator<EInfrastructureActionType.SetIsDropdownOpen, boolean>(
  EInfrastructureActionType.SetIsDropdownOpen,
);
